import admin from "./admin";
import seller from "./seller";
import shared from "./shared";
import supplier from "./supplier";
import storeManager from "./storeManager";
import marketplaceManager from "./marketplaceManager";
import idea from "./idea";
import ideaLeader from "./ideaLeader";
import sellerSupporter from "./seller-supporter";
import adminSupporter from "./admin-supporter";
import designer from "./designer";
import designLeader from "./design-leader";
import sellerSupplier from "./seller-supplier";
import sellerAccountant from "./seller-accountant";
import artistRoutes from "./artist";
import artistLeaderRoutes from "./artist-leader";
import fulfillmentRoutes from "./seller-fulfillment";
import channelLeaderRoutes from "./seller-channel-leader";
import channelSellerRoutes from "./seller-channel-seller";
import channelIdeaRoutes from "./seller-channel-idea";
import channelSupportLeaderRoutes from './seller-channel-support-leader';
import channelSupporterRoutes from './seller-channel-supporter';
import platformManagerRoutes from "./seller-platform-manager";

export default [
  ...admin,
  ...seller,
  ...supplier,
  ...shared,
  ...storeManager,
  ...marketplaceManager,
  ...idea,
  ...ideaLeader,
  ...sellerSupporter,
  ...adminSupporter,
  ...designer,
  ...designLeader,
  ...sellerSupplier,
  ...sellerAccountant,
  ...artistRoutes,
  ...artistLeaderRoutes,
  ...fulfillmentRoutes,
  ...channelLeaderRoutes,
  ...channelSellerRoutes,
  ...channelIdeaRoutes,
  ...channelSupportLeaderRoutes,
  ...channelSupporterRoutes,
  ...platformManagerRoutes,
];
